/* BOLLIDE sticky add to cart for phones, v3 (Oct 1): restyled to the site system:
   white surfaces, hairlines, square corners, sentence case, no tracking, the
   straight-on hat photos in place of colour squares, no decorative icons.
   v2 (Sep 26):
   A docked bar in the site's own language: square corners, one hairline,
   the same brown button as the product form. Tapping (or swiping up on) its
   color field raises a sheet from the bar: the hat in every color, large
   labeled color squares like the ones on the page, and the same Add to cart
   button stretched across. One spring drives the whole motion, so it can be
   interrupted, dragged and flicked like a native sheet.
   Sized for older shoppers: 56px buttons, 72px bar, color squares in tiles
   about 90 x 84px with the name printed under each, 14px+ text in dark ink,
   and a 44px close button.
   Every touch gets an answer: a haptic tick on taps and on each color as you
   swipe, a glint that crosses the button while the page scrolls, and a
   shimmer on the button until the cart opens, then a double tick.
   Next to the button the sheet repeats proof the page already has: the
   Okendo rating, the preorder ship date, free returns, and the wallet this
   phone already uses (Apple Pay or Google Pay), taken from the store's own
   enabled payment icons so it is never shown when it is not accepted.
   Loaded from snippets/color_swatches.liquid. If this file fails to load, the
   bar keeps its inline swatches. */
(function () {
  'use strict';

  if (window.BollideColorPanel) return;
  window.BollideColorPanel = true;

  var PHONE = window.matchMedia('(max-width: 767px)');
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
  var OPEN = { response: 0.5, damping: 0.9 };
  var CLOSE = { response: 0.38, damping: 0.95 };
  var BROWN = '#331f19';
  var CREAM = '#ffffff';
  var TILE = '#ffffff';
  var INK = '#1d140f';
  var MUTED = 'rgba(29,20,15,.62)';
  // the matched straight-on photos (Shopify > Files), one per colour.
  // Oct 16: the front embroidery is shown at its real, smaller size, and the
  // cotton twill colours have their own photos in the same framing.
  var FILES = 'https://cdn.shopify.com/s/files/1/0619/7834/5583/files/';
  var CUTS = {
    'alabaster': 'bollide-panel-hat-alabaster-front-small-logo.png',
    'espresso': 'bollide-panel-hat-espresso-front-small-logo.png',
    'merlot': 'bollide-panel-hat-merlot-front-small-logo.png',
    'forest': 'bollide-panel-hat-forest-front-small-logo.png',
    'midnight': 'bollide-panel-hat-midnight-front-small-logo.png',
    'charcoal': 'bollide-panel-hat-charcoal-front-small-logo.png',
    'noir': 'bollide-panel-hat-noir-front-small-logo.png',
    'camel': 'bollide-panel-hat-camel-front-small-logo.png',
    'rose pink': 'bollide-panel-hat-rose-pink-front-small-logo.png',
    'denim blue': 'bollide-panel-cotton-twill-denim-blue-front-eyelets.png',
    'black': 'bollide-panel-cotton-twill-black-front-eyelets.png',
    'khaki': 'bollide-panel-cotton-twill-khaki-front-eyelets.png'
  };
  function cutout(name, view, w) {
    var k = String(name || '').replace(/\s+/g, ' ').trim().toLowerCase();
    return CUTS[k] ? FILES + CUTS[k] + '?width=' + (w || 800) : '';
  }
  var UNAVAILABLE = /sold\s*out|unavailable|out\s*of\s*stock|coming\s*soon/i;
  var MONTHS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  var IOS = /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  var ANDROID = /Android/i.test(navigator.userAgent);
  var CHEVRON = '<svg class="bl-chip__chev" viewBox="0 0 12 12" aria-hidden="true"><path d="M3 7.6 6 4.6l3 3" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var XMARK = '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2.5 2.5l7 7m0-7l-7 7" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
  var STAR = '<svg class="bl-star" viewBox="0 0 12 12" aria-hidden="true"><path d="M6 1l1.25 3.58 3.79.08-3.02 2.3 1.1 3.63L6 8.42l-3.12 2.17 1.1-3.63-3.02-2.3 3.79-.08z" fill="currentColor"/></svg>';
  var BOX = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2.5 5 8 2.5 13.5 5v6L8 13.5 2.5 11zM2.5 5 8 7.5 13.5 5M8 7.5v6" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/></svg>';
  var RETURN = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M6 3.5 3 6.5l3 3M3 6.5h6.5a3 3 0 0 1 0 6H8" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var el = {};
  var colors = [];
  var trust = null;
  var st = {
    p: 0, v: 0, to: 0, cfg: OPEN, raf: 0, last: 0, mounted: false, focused: false, focusBack: false, geo: null,
    shown: -1, committed: -1, pending: null, jump: null, pageW: 1, cx: [], cy: [], ring: 62, ringFade: 1,
    pagerRaf: 0, settleTimer: 0, drag: null, swallowClick: false, media: null, mediaCbs: null,
    adding: false, addTimer: 0, nudged: false
  };

  /* ---------- helpers ---------- */

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function ramp(p, a, b) { var t = clamp((p - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
  function key(v) { return String(v || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function esc(v) { return String(v || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function bar() { return document.getElementById('sticky-atc'); }
  function cta() { return q('#sticky-atc .sticky-atc-btn'); }
  function ctaLabel() { var b = cta(); return b ? (q('[data-add-to-cart-text]', b) || b) : null; }
  function buyable(b) { return !!b && !b.disabled && b.getAttribute('aria-disabled') !== 'true' && !UNAVAILABLE.test(b.textContent || ''); }
  function push(action, color) {
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'bollide_sticky_color_panel', panel_action: action, panel_color: color || '' }); } catch (e) {}
  }

  // Haptics. iOS 18+ Safari plays the system tick when a switch control is
  // toggled; Android uses the vibration API. Both stay silent elsewhere.
  var haptic = (function () {
    var label = null;
    function toggle() {
      if (!label) {
        label = document.createElement('label');
        label.setAttribute('aria-hidden', 'true');
        label.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none';
        var input = document.createElement('input');
        input.type = 'checkbox';
        input.setAttribute('switch', '');
        input.tabIndex = -1;
        label.appendChild(input);
        label.addEventListener('click', function (e) { e.stopPropagation(); });
        document.body.appendChild(label);
      }
      label.click();
    }
    return function (kind) {
      try {
        if (IOS) {
          toggle();
          if (kind === 'success') setTimeout(toggle, 120);
        } else if (navigator.vibrate) {
          navigator.vibrate(kind === 'success' ? [10, 90, 16] : kind === 'detent' ? 5 : 7);
        }
      } catch (e) {}
    };
  })();

  /* ---------- data ---------- */

  function readColors() {
    var config = window.BOLLIDE_STICKY_ATC_PRODUCT || {};
    var variants = Array.isArray(config.variants) ? config.variants : [];
    var index = typeof config.colorOptionIndex === 'number' ? config.colorOptionIndex : 0;
    return qa('#sticky-atc .sticky-atc-color-swatch[data-sticky-color]').map(function (button) {
      var name = button.getAttribute('data-sticky-color');
      var matches = variants.filter(function (v) { return key([v.option1, v.option2, v.option3][index]) === key(name); });
      var variant = matches.filter(function (v) { return v.available; })[0] || matches[0] || null;
      return { name: name, hex: button.style.getPropertyValue('--bollide-sticky-swatch').trim() || '#cccccc', variant: variant };
    });
  }

  // Proof that already exists on the page, gathered once when the sheet is
  // first built. Anything missing is simply left out.
  function readTrust() {
    var out = { rating: null, ship: '', returns: false, pay: null, payName: '' };

    var r = q('.oke-sr-rating');
    var n = q('.oke-sr-count-number');
    var rating = r ? parseFloat(r.textContent) : NaN;
    var count = n ? parseInt(String(n.textContent).replace(/[^\d]/g, ''), 10) : NaN;
    if (rating >= 4 && count > 0) out.rating = { value: rating.toFixed(1), count: count };

    var m = null;
    qa('p').some(function (p) {
      m = /begins shipping\s+([a-z]+)\s+(\d{1,2}),?\s*(\d{4})?/i.exec(p.textContent || '');
      return !!m;
    });
    if (m) {
      var month = MONTHS.indexOf(m[1].toLowerCase());
      var year = m[3] ? Number(m[3]) : new Date().getFullYear();
      if (month !== -1 && new Date(year, month, Number(m[2]), 23, 59).getTime() > Date.now()) {
        out.ship = 'Ships ' + MONTHS[month].charAt(0).toUpperCase() + MONTHS[month].slice(1) + ' ' + Number(m[2]);
      }
    }

    out.returns = /free\s+returns|free\s+shipping\s*(&|and)\s*returns/i.test(document.body.textContent || '');

    var titles = qa('svg title');
    function mark(name) {
      var t = titles.filter(function (x) { return key(x.textContent) === name; })[0];
      return t && t.closest ? t.closest('svg') : null;
    }
    var apple = false;
    try { apple = !!(window.ApplePaySession && window.ApplePaySession.canMakePayments()); } catch (e) {}
    var wanted = apple ? [['apple pay', 'Apple Pay']] : ANDROID ? [['google pay', 'Google Pay']] : [];
    wanted.push(['shop pay', 'Shop Pay']);
    for (var i = 0; i < wanted.length; i += 1) {
      var svg = mark(wanted[i][0]);
      if (svg) { out.pay = svg; out.payName = wanted[i][1]; break; }
    }
    return out;
  }

  function legacySwatch(name) {
    return qa('#sticky-atc .sticky-atc-color-swatch[data-sticky-color]').filter(function (b) {
      return key(b.getAttribute('data-sticky-color')) === key(name);
    })[0] || null;
  }

  function statusOf(color) {
    var v = color && color.variant;
    if (!v || v.available === false) return 'Coming soon';
    return v.isPreorder ? 'Preorder' : 'In stock';
  }

  function shipText(color) {
    var s = statusOf(color);
    return s === 'Preorder' ? ((trust && trust.ship) || 'Preorder') : s;
  }

  function currentIndex() {
    var summary = document.getElementById('sticky-atc-selected-summary');
    var name = summary ? summary.textContent : '';
    var active = q('#sticky-atc .sticky-atc-color-swatch.is-active');
    for (var i = 0; i < colors.length; i += 1) {
      if (key(colors[i].name) === key(name)) return i;
    }
    for (i = 0; i < colors.length; i += 1) {
      if (active && key(colors[i].name) === key(active.getAttribute('data-sticky-color'))) return i;
    }
    return 0;
  }

  function loadMedia(cb) {
    if (st.media) { if (cb) cb(st.media); return; }
    if (st.mediaCbs) { if (cb) st.mediaCbs.push(cb); return; }
    st.mediaCbs = cb ? [cb] : [];
    fetch(window.location.pathname.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { st.media = (data && data.media) || []; })
      .catch(function () { st.media = []; })
      .then(function () {
        var cbs = st.mediaCbs || [];
        st.mediaCbs = null;
        cbs.forEach(function (f) { f(st.media); });
      });
  }

  function imageFor(name) {
    var cut = cutout(name, 'front', 900);
    if (cut) return cut;
    var k = key(name);
    var media = st.media || [];
    function alt(m) { return key(m.alt); }
    function src(m) { return m.src || (m.preview_image && m.preview_image.src) || ''; }
    var pick = media.filter(function (m) { return alt(m) === 'catalog only - ' + k; })[0] ||
      media.filter(function (m) { return alt(m) === k && /-interior/i.test(src(m)); })[0] ||
      media.filter(function (m) { return alt(m) === k; })[0];
    var url = pick ? src(pick) : '';
    if (!url) {
      var c = colors.filter(function (x) { return key(x.name) === k; })[0];
      return c && c.variant && c.variant.image ? String(c.variant.image).replace(/([?&])width=\d+/, '$1width=800') : '';
    }
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=800';
  }

  function applyImages() {
    if (!el.pages) return;
    var order = el.pages.map(function (s, i) { return i; }).sort(function (a, b) {
      return Math.abs(a - st.shown) - Math.abs(b - st.shown);
    });
    order.forEach(function (i) {
      var img = el.pages[i].img;
      var url = imageFor(colors[i].name);
      if (!url || img.getAttribute('src') === url) return;
      img.onload = function () { img.classList.add('is-loaded'); paintPager(); };
      if (i === st.shown && 'fetchPriority' in img) img.fetchPriority = 'high';
      img.src = url;
      if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
    });
  }

  function prefetch() {
    loadMedia(function () {
      var url = imageFor((colors[currentIndex()] || {}).name);
      if (url) { var img = new Image(); img.src = url; }
    });
  }

  /* ---------- styles ---------- */

  function injectStyles() {
    if (document.getElementById('bl-color-panel-css')) return;
    var B = 'html body #sticky-atc#sticky-atc.bl-sheet';
    var S = 'html body .bl-sheet-ui ';
    var RULE = 'rgba(51,31,25,.14)';
    var SPRINGY = 'cubic-bezier(.2,.9,.3,1.25)';
    var css = [
      '.bl-chip,.bl-sheen{display:none}',
      '.bl-sr{position:absolute!important;width:1px!important;height:1px!important;margin:-1px!important;padding:0!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;white-space:nowrap!important;border:0!important}',
      '@keyframes bl-imgin{from{opacity:0;filter:blur(12px)}}',
      '@keyframes bl-shimmer{from{background-position:120% 0}to{background-position:-20% 0}}',
      '@keyframes bl-glint{from{transform:translate3d(-120%,0,0) skewX(-16deg)}to{transform:translate3d(2000%,0,0) skewX(-16deg)}}',
      // the price inside the button sits apart from the verb at every width
      'html body #sticky-atc .sticky-atc-btn .bl-price{margin-left:.6em}',
      '@media (max-width:767px){',
      // the bar: docked like the rest of the site, square, one hairline on top
      B + '{left:0!important;right:0!important;bottom:0!important;top:auto!important;width:auto!important;padding:0 0 env(safe-area-inset-bottom)!important;border:0!important;border-top:1px solid rgba(29,20,15,.12)!important;border-radius:0!important;background:' + CREAM + '!important;-webkit-backdrop-filter:none!important;backdrop-filter:none!important;box-shadow:none!important}',
      B + ' .sticky-atc-inner{max-width:none!important;min-height:0!important;margin:0!important;padding:10px 14px 10px 10px!important;display:grid!important;grid-template-columns:minmax(0,1fr) auto!important;grid-template-rows:56px!important;grid-template-areas:"chip button"!important;column-gap:12px!important;row-gap:0!important;align-items:center!important;border-radius:0!important;position:relative!important}',
      B + ' .sticky-atc-selected-summary,' + B + ' .sticky-atc-fit-note,' + B + ' .sticky-atc-selector-group,' + B + ' .sticky-atc-price{display:none!important}',
      // the button matches the product form's own button, only larger
      B + ' .sticky-atc-btn{grid-area:button!important;z-index:1!important;height:56px!important;min-width:0!important;width:auto!important;margin:0!important;padding:0 22px!important;border:0!important;border-radius:0!important;background:' + BROWN + '!important;color:#fff!important;font:400 15px/1 acumin-pro,sans-serif!important;letter-spacing:.01em!important;text-transform:none!important;box-shadow:none!important;transition:scale .3s ' + SPRINGY + ',background-color .2s ease!important;-webkit-tap-highlight-color:transparent}',
      B + ' .sticky-atc-btn:active{scale:.97;background:#241613!important}',
      B + ' .sticky-atc-btn:after{text-transform:none!important;letter-spacing:.01em!important}',
      B + ' .sticky-atc-btn .bl-price{margin-left:12px;opacity:.7}',
      B + ' .sticky-atc-btn:disabled,' + B + ' .sticky-atc-btn.is-coming-soon{background:#d8d5cf!important;color:rgba(51,31,25,.72)!important}',
      // working: a light passes across the button until the cart opens
      B + ' .sticky-atc-btn.bl-adding{background-image:linear-gradient(105deg,rgba(255,255,255,0) 38%,rgba(255,255,255,.2) 50%,rgba(255,255,255,0) 62%)!important;background-size:300% 100%!important;background-repeat:no-repeat!important;animation:bl-shimmer 1.15s cubic-bezier(.45,0,.25,1) infinite!important;cursor:progress!important}',
      '@media (prefers-reduced-motion:reduce){' + B + ' .sticky-atc-btn.bl-adding{animation:none!important;background-image:none!important;opacity:.82!important}}',
      // the color field: reads like a select box, with a square swatch like the page's
      B + ' .bl-chip{grid-area:chip;position:relative;z-index:1;display:flex!important;align-items:center;gap:10px;min-width:0;height:56px;margin:0!important;padding:0 4px 0 0!important;border:0!important;border-radius:0!important;background:transparent!important;box-shadow:none!important;color:' + BROWN + '!important;text-align:left;cursor:pointer;touch-action:none;-webkit-tap-highlight-color:transparent;transition:scale .3s ' + SPRINGY + ',border-color .2s ease}',
      B + ' .bl-chip:active{scale:.98}',
      B + ' .bl-chip__img{flex:none;display:block;width:54px;height:54px;margin:0 -2px 0 -4px;object-fit:contain}',
      B + ' .bl-chip__img[hidden],' + B + ' .bl-chip__dot[hidden]{display:none!important}',
      B + ' .bl-chip:focus-visible{outline:2px solid ' + BROWN + ';outline-offset:2px}',
      B + ' .bl-chip__dot{flex:none;box-sizing:border-box;width:30px;height:30px;border-radius:1px;background:var(--c);border:1px solid rgba(51,31,25,.18);box-shadow:inset 0 0 0 1px rgba(251,250,247,.82)}',
      B + ' .bl-chip__text{display:flex;flex-direction:column;justify-content:center;flex:1 1 auto;min-width:0}',
      B + ' .bl-chip__name{font:400 16px/20px acumin-pro,sans-serif;color:' + INK + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
      B + ' .bl-chip__more{font:400 13px/17px acumin-pro,sans-serif;letter-spacing:0;text-transform:none;color:' + MUTED + ';white-space:nowrap}',
      B + ' .bl-chip__chev{flex:none;width:14px;height:14px;margin-left:auto}',
      '@media (max-width:389px){' + B + ' .sticky-atc-btn{padding:0 16px!important;font-size:14px!important}}',
      '@media (max-width:369px){' + B + ' .bl-chip{gap:8px;padding:0 8px 0 8px!important}' + B + ' .bl-chip__dot{width:26px;height:26px}}',
      // a glint that crosses the button only while the page scrolls
      B + ' .bl-sheen{display:none!important}',
      B + ' .bl-sheen:before{content:"";position:absolute;top:-20%;bottom:-20%;left:0;width:22%;background:linear-gradient(90deg,rgba(255,255,255,0),rgba(255,255,255,.2) 50%,rgba(255,255,255,0));transform:translate3d(-120%,0,0) skewX(-16deg)}',
      '@supports (animation-timeline:scroll()){@media (prefers-reduced-motion:no-preference){' + B + ' .bl-sheen:before{animation:bl-glint linear both;animation-iteration-count:7;animation-timeline:scroll(root)}}}',
      // while the sheet is up, the bar hands its surface to the sheet
      B + '.bl-open{z-index:10003!important;background:transparent!important;border-top-color:transparent!important;box-shadow:none!important}',
      B + '.bl-open .sticky-atc-inner{grid-template-areas:"button button"!important}',
      B + '.bl-open .bl-chip{position:absolute!important;left:12px;top:8px;pointer-events:none}',
      B + '.bl-open .bl-sheen{display:none}',
      B + '.bl-open .sticky-atc-btn{width:100%!important}',
      'html.bl-sheet-ready body.template-product .needsclick[class*="kl-teaser-"]{bottom:calc(84px + env(safe-area-inset-bottom))!important}',
      'html.bl-sheet-open,html.bl-sheet-open body{overflow:hidden!important;overscroll-behavior:none!important}',
      'html.bl-sheet-open [id^="alia-root"],html.bl-sheet-open .needsclick[class*="kl-teaser-"]{opacity:0!important;pointer-events:none!important;transition:opacity .25s ease}',
      // dim, surface and content
      'html body .bl-dim{position:fixed;inset:0;z-index:10000;background:#1a100c;opacity:0;touch-action:none;-webkit-tap-highlight-color:transparent}',
      'html body .bl-surface{position:fixed;z-index:10001;margin:0;background:' + CREAM + ';box-shadow:inset 0 1px 0 rgba(29,20,15,.12);pointer-events:none}',
      'html body .bl-dim[hidden],html body .bl-surface[hidden],html body .bl-sheet-ui[hidden]{display:none!important}',
      S + '{position:fixed;left:0;right:0;bottom:0;z-index:10002;box-sizing:border-box;margin:0;padding:0 12px;color:' + BROWN + ';font-family:acumin-pro,sans-serif;touch-action:none;-webkit-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}',
      S + '.bl-grab{position:absolute;top:6px;left:50%;width:36px;height:4px;margin:0 0 0 -18px;border-radius:2px;background:rgba(51,31,25,.2)}',
      S + '.bl-head{display:flex;align-items:center;justify-content:center;height:56px;margin:0 -12px;padding:6px 56px 0;border-bottom:1px solid rgba(51,31,25,.1)}',
      S + '.bl-title{margin:0!important;padding:0!important;font:400 15px/20px acumin-pro,sans-serif!important;letter-spacing:0!important;text-transform:none!important;color:' + INK + '!important;white-space:nowrap}',
      S + '.bl-x{position:absolute;top:9px;right:4px;display:grid!important;place-items:center;width:44px!important;height:44px!important;min-width:0!important;margin:0!important;padding:0!important;border:0!important;border-radius:0!important;background:none!important;color:' + BROWN + '!important;box-shadow:none!important;cursor:pointer;transition:scale .3s ' + SPRINGY + '}',
      S + '.bl-x:active{scale:.86}',
      S + '.bl-x svg{width:16px;height:16px}',
      S + '.bl-x:focus-visible{outline:2px solid ' + BROWN + ';outline-offset:-6px}',
      S + '.bl-tile{position:relative;margin:12px 0 0;height:clamp(150px,calc(85vh - 440px),250px);height:clamp(150px,calc(85dvh - 440px),250px);border-radius:0;background:' + TILE + ';overflow:hidden;isolation:isolate}',
      S + '.bl-pager{display:flex;height:100%;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;touch-action:pan-x;overscroll-behavior-x:contain}',
      S + '.bl-pager::-webkit-scrollbar{display:none}',
      S + '.bl-page{position:relative;flex:0 0 100%;height:100%;margin:0!important;padding:0!important;scroll-snap-align:center;scroll-snap-stop:always;overflow:hidden}',
      // the photo is sized in measure() so short screens still show the whole hat;
      // its side edges fade into the tile so there is no seam
      S + '.bl-page img{position:absolute!important;left:0;top:0;width:100%;height:100%;max-width:none!important;object-fit:cover;opacity:0;will-change:transform,opacity;object-fit:contain!important;-webkit-user-drag:none;pointer-events:none}',
      S + '.bl-page img.is-loaded{opacity:1;animation:bl-imgin .6s cubic-bezier(.2,.8,.2,1) backwards}',
      S + '.bl-name{position:relative;height:36px;margin:14px 0 0!important;font:italic 400 30px/36px big-caslon-fb,"Big Caslon","Big Caslon FB","Libre Caslon Display",Georgia,serif!important;letter-spacing:-.01em!important;text-align:center;color:' + BROWN + '!important}',
      S + '.bl-name span{position:absolute;left:0;right:0;top:0;white-space:nowrap}',
      S + '.bl-meta{display:flex;align-items:center;justify-content:center;gap:6px;height:20px;margin:2px 0 0!important;padding:0!important;font:400 14px/20px acumin-pro,sans-serif!important;letter-spacing:0!important;color:' + MUTED + '!important;white-space:nowrap}',
      S + '.bl-meta b{font-weight:400!important;color:' + BROWN + '!important}',
      S + '.bl-stars{display:flex;gap:1px;color:' + BROWN + '}',
      S + '.bl-star{display:block;width:13px;height:13px;flex:none}',
      // large labeled color squares, four to a row, styled like the page's swatches
      S + '.bl-swatches{position:relative;display:flex;flex-wrap:wrap;justify-content:center;row-gap:6px;margin:12px 0 0;padding:0}',
      S + '.bl-swatch{position:relative;flex:0 0 25%!important;display:flex!important;flex-direction:column;align-items:center;justify-content:center;gap:7px;height:84px!important;min-width:0!important;margin:0!important;padding:0!important;border:0!important;border-radius:4px!important;background:none!important;box-shadow:none!important;color:inherit!important;cursor:pointer;-webkit-tap-highlight-color:transparent}',
      S + '.bl-swatch__dot{position:relative;display:block;box-sizing:border-box;width:58px;height:58px;border-radius:0;background:var(--c);border:1px solid rgba(29,20,15,.14);box-shadow:none;transition:scale .3s cubic-bezier(.2,.9,.3,1.3)}',
      S + '.bl-swatch__dot.is-photo{background:#fff var(--img) center/118% no-repeat;border:0}',
      S + '.bl-swatch:active .bl-swatch__dot{scale:.9}',
      S + '.bl-swatch__label{display:block;max-width:100%;overflow:hidden;text-overflow:ellipsis;font:400 13px/17px acumin-pro,sans-serif;letter-spacing:0;color:' + MUTED + ';white-space:nowrap}',
      S + '.bl-swatch[aria-checked="true"] .bl-swatch__label{color:' + INK + '}',
      S + '.bl-swatch:focus-visible{outline:2px solid ' + BROWN + ';outline-offset:-2px}',
      S + '.bl-swatch.is-coming-soon .bl-swatch__dot:after{content:"";position:absolute;left:4px;right:4px;top:50%;height:1.5px;margin-top:-.75px;background:rgba(255,255,255,.92);box-shadow:0 0 0 .5px rgba(51,31,25,.24);transform:rotate(-45deg)}',
      S + '.bl-ring{position:absolute;left:0;top:0;width:62px;height:62px;box-sizing:border-box;border:1px solid ' + INK + ';border-radius:0;pointer-events:none;will-change:transform,opacity}',
      S + '.bl-assure{display:flex;flex-wrap:wrap;justify-content:center;align-items:center;column-gap:16px;row-gap:4px;margin:12px 0 0!important;padding:0!important;list-style:none!important;font:400 14px/20px acumin-pro,sans-serif!important;letter-spacing:0!important;color:' + MUTED + '!important}',
      S + '.bl-assure li{display:flex;align-items:center;gap:6px;margin:0!important;padding:0!important;list-style:none!important;background:none!important;white-space:nowrap}',
      S + '.bl-assure li:before,' + S + '.bl-assure li:after{display:none!important}',
      S + '.bl-assure li>svg{width:16px;height:16px;flex:none}',
      S + '.bl-assure .bl-pay svg{display:block;width:auto;height:20px}',
      S + '.bl-spacer{height:calc(76px + env(safe-area-inset-bottom))}',
      '}'
    ].join('\n');
    var style = document.createElement('style');
    style.id = 'bl-color-panel-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  /* ---------- the bar ---------- */

  function buildChip() {
    var inner = q('#sticky-atc .sticky-atc-inner');
    if (!inner || q('.bl-chip', inner)) return false;
    var chip = document.createElement('button');
    chip.type = 'button';
    chip.className = 'bl-chip';
    chip.setAttribute('aria-haspopup', 'dialog');
    chip.setAttribute('aria-expanded', 'false');
    chip.setAttribute('aria-controls', 'bl-sheet');
    chip.innerHTML = '<img class="bl-chip__img" alt="" aria-hidden="true" decoding="async" hidden><span class="bl-chip__dot" aria-hidden="true"></span>' +
      '<span class="bl-chip__text" aria-hidden="true"><span class="bl-chip__name"></span>' +
      '<span class="bl-chip__more">Change color</span></span>' + CHEVRON;
    inner.insertBefore(chip, inner.firstChild);
    el.chip = chip;
    chip.addEventListener('pointerdown', onChipDown);
    chip.addEventListener('click', function (e) {
      e.preventDefault();
      if (st.swallowClick) { st.swallowClick = false; return; }
      haptic('tap');
      animateTo(st.mounted && st.to === 1 ? 0 : 1);
    });
    return true;
  }

  function updateChip() {
    if (!el.chip) return;
    var c = colors[currentIndex()];
    if (!c) return;
    q('.bl-chip__name', el.chip).textContent = c.name;
    q('.bl-chip__dot', el.chip).style.setProperty('--c', c.hex);
    var img = q('.bl-chip__img', el.chip), src = cutout(c.name, 'front', 160);
    img.hidden = !src;
    q('.bl-chip__dot', el.chip).hidden = !!src;
    if (src && img.getAttribute('src') !== src) img.src = src;
    el.chip.setAttribute('aria-label', 'Color: ' + c.name + '. See all ' + colors.length + ' colors');
  }

  /* ---------- the sheet ---------- */

  function buildSheet() {
    if (el.ui) return;
    var config = window.BOLLIDE_STICKY_ATC_PRODUCT || {};
    var title = config.productTitle || 'The Silk-Lined Hat';
    trust = readTrust();

    var meta = '';
    if (trust.rating) {
      meta = '<p class="bl-meta"><span class="bl-sr">Rated ' + esc(trust.rating.value) + ' out of 5 from ' + esc(trust.rating.count) + ' reviews</span>' +
        '<span aria-hidden="true" style="display:contents"><span class="bl-stars">' + STAR + STAR + STAR + STAR + STAR + '</span><b>' + esc(trust.rating.value) + '</b><span>from ' +
        esc(trust.rating.count.toLocaleString('en-US')) + ' reviews</span></span></p>';
    } else if (config.fitNote) {
      meta = '<p class="bl-meta">' + esc(config.fitNote) + '</p>';
    }

    var assure = '<ul class="bl-assure" aria-label="Delivery and payment">' +
      '<li><span class="bl-ship"></span></li>' +
      (trust.returns ? '<li><span>Free returns</span></li>' : '') +
      (trust.pay ? '<li class="bl-pay"><span class="bl-sr">' + esc(trust.payName) + ' accepted</span></li>' : '') +
      '</ul>';

    el.dim = document.createElement('div');
    el.dim.className = 'bl-dim';
    el.dim.hidden = true;
    el.surface = document.createElement('div');
    el.surface.className = 'bl-surface';
    el.surface.hidden = true;

    var ui = document.createElement('section');
    ui.className = 'bl-sheet-ui';
    ui.id = 'bl-sheet';
    ui.hidden = true;
    ui.setAttribute('role', 'dialog');
    ui.setAttribute('aria-labelledby', 'bl-sheet-title');
    ui.innerHTML = '<div class="bl-grab" aria-hidden="true"></div>' +
      '<div class="bl-head"><h2 class="bl-title" id="bl-sheet-title">Choose a color</h2></div>' +
      '<button type="button" class="bl-x" aria-label="Close">' + XMARK + '</button>' +
      '<div class="bl-tile"><div class="bl-pager">' + colors.map(function (c, i) {
        return '<figure class="bl-page" data-i="' + i + '"><img alt="' + esc(title + ' in ' + c.name) + '" decoding="async" draggable="false"></figure>';
      }).join('') + '</div></div>' +
      '<div class="bl-name" aria-live="polite"></div>' + meta +
      '<div class="bl-swatches" role="radiogroup" aria-label="Color"><span class="bl-ring" aria-hidden="true"></span>' +
      colors.map(function (c, i) {
        return '<button type="button" role="radio" aria-checked="false" tabindex="-1" class="bl-swatch' + (statusOf(c) === 'Coming soon' ? ' is-coming-soon' : '') + '" data-i="' + i + '" aria-label="' + esc(c.name + ', ' + statusOf(c)) + '">' +
          '<span class="bl-swatch__dot" aria-hidden="true"></span><span class="bl-swatch__label" aria-hidden="true">' + esc(c.name) + '</span></button>';
      }).join('') + '</div>' + assure +
      '<div class="bl-spacer" aria-hidden="true"></div>';

    if (trust.pay) {
      var copy = trust.pay.cloneNode(true);
      qa('title', copy).forEach(function (t) { t.remove(); });
      qa('[id]', copy).forEach(function (node) { node.removeAttribute('id'); });
      ['id', 'aria-labelledby', 'width', 'height', 'class'].forEach(function (a) { copy.removeAttribute(a); });
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('focusable', 'false');
      q('.bl-pay', ui).appendChild(copy);
    }

    document.body.appendChild(el.dim);
    document.body.appendChild(el.surface);
    document.body.appendChild(ui);

    el.ui = ui;
    el.grab = q('.bl-grab', ui);
    el.head = q('.bl-head', ui);
    el.x = q('.bl-x', ui);
    el.tile = q('.bl-tile', ui);
    el.pager = q('.bl-pager', ui);
    el.name = q('.bl-name', ui);
    el.meta = q('.bl-meta', ui);
    el.swatchWrap = q('.bl-swatches', ui);
    el.ring = q('.bl-ring', ui);
    el.assure = q('.bl-assure', ui);
    el.ship = q('.bl-ship', ui);
    el.swatches = qa('.bl-swatch', ui);
    el.dots = qa('.bl-swatch__dot', ui);
    el.pages = qa('.bl-page', ui).map(function (page) { return { page: page, img: q('img', page) }; });

    el.swatches.forEach(function (b, i) {
      el.dots[i].style.setProperty('--c', colors[i].hex);
      var sw = cutout(colors[i].name, 'front', 240);
      if (sw) { el.dots[i].style.setProperty('--img', 'url("' + sw + '")'); el.dots[i].classList.add('is-photo'); }
      b.addEventListener('click', function () { haptic('tap'); select(i); });
    });
    el.dim.addEventListener('click', function () { st.focusBack = true; animateTo(0); });
    el.x.addEventListener('click', function () { haptic('tap'); st.focusBack = true; animateTo(0); });
    el.pager.addEventListener('scroll', onPagerScroll, { passive: true });
    el.pager.addEventListener('scrollend', settlePager);
    ui.addEventListener('pointerdown', onSheetDown);
  }

  function measure() {
    var b = bar();
    var button = cta();
    var cap = b.getBoundingClientRect();
    var sheet = el.ui.getBoundingClientRect();
    b.classList.remove('bl-open');
    var compact = button.getBoundingClientRect();
    b.classList.add('bl-open');
    var full = button.getBoundingClientRect();
    st.geo = {
      cap: { l: cap.left, t: cap.top, r: cap.right, b: cap.bottom },
      sh: { l: sheet.left, t: sheet.top, r: sheet.right, b: sheet.bottom },
      ctaC: { l: compact.left, r: compact.right },
      ctaF: { l: full.left, r: full.right },
      travel: Math.max(1, cap.top - sheet.top)
    };
    st.pageW = el.pager.clientWidth || 1;
    // Square photos: fill the width on tall tiles, but never crop more than
    // about a quarter of the height, so the whole hat stays in view.
    var tw = el.tile.clientWidth;
    var th = el.tile.clientHeight;
    var side = colors.some(function (c) { return !!cutout(c.name); }) ? Math.min(tw, th * 1.12) : Math.max(th, Math.min(tw, th / 0.72));
    el.pages.forEach(function (pg) {
      var s = pg.img.style;
      s.setProperty('width', side.toFixed(1) + 'px', 'important');
      s.setProperty('height', side.toFixed(1) + 'px', 'important');
      s.setProperty('left', ((tw - side) / 2).toFixed(1) + 'px', 'important');
      s.setProperty('top', ((th - side) / 2).toFixed(1) + 'px', 'important');
    });
    st.cx = [];
    st.cy = [];
    el.swatches.forEach(function (s, i) {
      var d = el.dots[i];
      st.cx.push(s.offsetLeft + d.offsetLeft + d.offsetWidth / 2);
      st.cy.push(s.offsetTop + d.offsetTop + d.offsetHeight / 2);
    });
    st.ring = el.dots.length ? el.dots[0].offsetWidth + 12 : 62;
  }

  /* ---------- the motion ---------- */

  function fade(node, p, a, b, dy, s) {
    if (!node) return;
    var e = ramp(p, a, b);
    node.style.opacity = e.toFixed(3);
    node.style.transform = 'translate3d(0,' + ((1 - e) * dy).toFixed(2) + 'px,0)' + (s ? ' scale(' + (1 - (1 - e) * s).toFixed(4) + ')' : '');
  }

  function ringOpacity() {
    el.ring.style.opacity = (ramp(clamp(st.p, 0, 1), 0.72, 1) * st.ringFade).toFixed(3);
  }

  function render() {
    var g = st.geo;
    if (!g) return;
    var q1 = clamp(st.p, 0, 1);
    var lift = st.p > 1 ? (st.p - 1) * g.travel : 0;
    var l = lerp(g.cap.l, g.sh.l, q1);
    var r = lerp(g.cap.r, g.sh.r, q1);
    var t = lerp(g.cap.t, g.sh.t, q1);
    var b = lerp(g.cap.b, g.sh.b, q1);

    var s = el.surface.style;
    s.left = l.toFixed(2) + 'px';
    s.top = (t - lift).toFixed(2) + 'px';
    s.width = (r - l).toFixed(2) + 'px';
    s.height = (b - t + lift).toFixed(2) + 'px';

    var u = el.ui.style;
    u.clipPath = 'inset(' + (t - g.sh.t).toFixed(2) + 'px ' + (g.sh.r - r).toFixed(2) + 'px ' + (g.sh.b - b).toFixed(2) + 'px ' + (l - g.sh.l).toFixed(2) + 'px)';
    u.transform = lift ? 'translate3d(0,' + (-lift).toFixed(2) + 'px,0)' : '';

    var e = ramp(q1, 0.42, 0.95);
    el.grab.style.opacity = e.toFixed(3);
    el.x.style.opacity = e.toFixed(3);
    el.x.style.transform = 'scale(' + (0.7 + 0.3 * e).toFixed(4) + ')';
    fade(el.head, q1, 0.42, 0.95, 8);
    fade(el.tile, q1, 0.14, 0.8, 34, 0.06);
    fade(el.name, q1, 0.3, 0.88, 18);
    fade(el.meta, q1, 0.36, 0.92, 14);
    el.swatches.forEach(function (sw, i) {
      var k = ramp(q1, 0.34 + i * 0.035, 0.8 + i * 0.028);
      sw.style.opacity = k.toFixed(3);
      sw.style.transform = 'translate3d(0,' + ((1 - k) * 16).toFixed(2) + 'px,0) scale(' + (0.8 + 0.2 * k).toFixed(4) + ')';
    });
    ringOpacity();
    fade(el.assure, q1, 0.5, 0.98, 10);

    var c = 1 - ramp(q1, 0, 0.3);
    el.chip.style.opacity = c.toFixed(3);
    el.chip.style.transform = 'translate3d(0,' + (-(1 - c) * 10).toFixed(2) + 'px,0)';

    var button = cta();
    var label = ctaLabel();
    if (button) {
      var cutL = Math.max(0, (g.ctaC.l - g.ctaF.l) * (1 - q1));
      var cutR = Math.max(0, (g.ctaF.r - g.ctaC.r) * (1 - q1));
      button.style.clipPath = 'inset(0 ' + cutR.toFixed(2) + 'px 0 ' + cutL.toFixed(2) + 'px round 4px)';
      if (label && label !== button) {
        var dx = ((g.ctaC.l + g.ctaC.r) / 2 - (g.ctaF.l + g.ctaF.r) / 2) * (1 - q1);
        label.style.transition = 'none';
        label.style.display = 'inline-block';
        label.style.transform = 'translate3d(' + dx.toFixed(2) + 'px,0,0)';
      }
    }
    el.dim.style.opacity = (0.38 * q1).toFixed(3);
  }

  function step(now) {
    st.raf = 0;
    var dt = clamp((now - st.last) / 1000, 0.001, 0.034);
    st.last = now;
    var k = Math.pow(2 * Math.PI / st.cfg.response, 2);
    var c = 4 * Math.PI * st.cfg.damping / st.cfg.response;
    for (var i = 0; i < 4; i += 1) {
      var a = -k * (st.p - st.to) - c * st.v;
      st.v += a * dt / 4;
      st.p += st.v * dt / 4;
    }
    if (Math.abs(st.p - st.to) < 0.0008 && Math.abs(st.v) < 0.01) {
      st.p = st.to;
      st.v = 0;
      render();
      rest();
      return;
    }
    render();
    st.raf = window.requestAnimationFrame(step);
  }

  function animateTo(to, velocity) {
    if (to === 1 && !mount()) return;
    if (!st.mounted) return;
    st.to = to;
    st.cfg = to === 1 ? OPEN : CLOSE;
    if (typeof velocity === 'number') st.v = velocity;
    if (to === 1) el.chip.setAttribute('aria-expanded', 'true');
    if (REDUCED.matches) {
      st.p = to;
      st.v = 0;
      render();
      rest();
      return;
    }
    if (!st.raf) {
      st.last = window.performance.now();
      st.raf = window.requestAnimationFrame(step);
    }
  }

  function rest() {
    if (st.to === 0) {
      unmount(st.focusBack);
      return;
    }
    if (!st.focused) {
      st.focused = true;
      var sw = el.swatches[st.shown];
      if (sw) sw.focus({ preventScroll: true });
    }
  }

  function stopSpring() {
    if (st.raf) window.cancelAnimationFrame(st.raf);
    st.raf = 0;
  }

  function mount() {
    if (st.mounted) return true;
    if (!PHONE.matches) return false;
    var b = bar();
    if (!b || !cta()) return false;
    colors = readColors();
    if (colors.length < 2) return false;
    if (b.getAnimations) {
      b.getAnimations({ subtree: true }).forEach(function (a) {
        if (a.timeline === document.timeline) { try { a.finish(); } catch (e) {} }
      });
    }
    buildSheet();
    st.mounted = true;
    st.focused = false;
    st.focusBack = false;
    st.p = 0;
    st.v = 0;
    el.chip.style.width = el.chip.getBoundingClientRect().width + 'px';
    el.dim.hidden = false;
    el.surface.hidden = false;
    el.ui.hidden = false;
    document.documentElement.classList.add('bl-sheet-open');
    b.classList.add('bl-open');
    var idx = currentIndex();
    st.committed = idx;
    st.pending = null;
    st.jump = null;
    st.shown = -1;
    st.ringFade = 1;
    showColor(idx, false);
    measure();
    el.pager.scrollLeft = idx * st.pageW;
    paintPager();
    loadMedia(applyImages);
    render();
    document.addEventListener('keydown', onKey, true);
    document.addEventListener('touchmove', blockTouch, { passive: false });
    window.addEventListener('pointermove', onMove, { passive: false });
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
    push('open', colors[idx].name);
    return true;
  }

  function unmount(focusBack) {
    if (!st.mounted) return;
    st.mounted = false;
    stopSpring();
    st.p = 0;
    st.v = 0;
    st.to = 0;
    st.drag = null;
    st.jump = null;
    clearTimeout(st.settleTimer);
    document.removeEventListener('keydown', onKey, true);
    document.removeEventListener('touchmove', blockTouch, { passive: false });
    window.removeEventListener('pointermove', onMove, { passive: false });
    window.removeEventListener('pointerup', onUp);
    window.removeEventListener('pointercancel', onUp);
    el.dim.hidden = true;
    el.surface.hidden = true;
    el.ui.hidden = true;
    el.ui.style.transform = '';
    var button = cta();
    var label = ctaLabel();
    if (button) button.style.clipPath = '';
    if (label && label !== button) { label.style.transform = ''; label.style.display = ''; label.style.transition = ''; }
    el.chip.style.opacity = '';
    el.chip.style.transform = '';
    el.chip.style.width = '';
    var b = bar();
    if (b) b.classList.remove('bl-open');
    document.documentElement.classList.remove('bl-sheet-open');
    el.chip.setAttribute('aria-expanded', 'false');
    updateChip();
    if (focusBack) el.chip.focus({ preventScroll: true });
    push('close', colors[st.shown] && colors[st.shown].name);
  }

  // Leaves quickly when the cart takes over.
  function dismissFast() {
    if (!st.mounted) return;
    stopSpring();
    var d = REDUCED.matches ? 1 : 240;
    var out = [];
    if (el.ui.animate) {
      [el.ui, el.surface].forEach(function (n) {
        out.push(n.animate([
          { opacity: 1, transform: 'none' },
          { opacity: 0, transform: 'translate3d(0,24px,0)' }
        ], { duration: d, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' }));
      });
      out.push(el.dim.animate([{ opacity: el.dim.style.opacity || 0.38 }, { opacity: 0 }], { duration: d, easing: 'ease-out', fill: 'forwards' }));
    }
    setTimeout(function () {
      unmount(false);
      out.forEach(function (a) { try { a.cancel(); } catch (e) {} });
    }, d + 10);
  }

  /* ---------- adding to the cart ---------- */

  function startAdding(button) {
    st.adding = true;
    button.classList.add('bl-adding');
    button.setAttribute('aria-busy', 'true');
    clearTimeout(st.addTimer);
    st.addTimer = setTimeout(function () { finishAdding(false); }, 4000);
  }

  function finishAdding(ok) {
    if (!st.adding) return;
    st.adding = false;
    clearTimeout(st.addTimer);
    var button = cta();
    if (button) {
      button.classList.remove('bl-adding');
      button.removeAttribute('aria-busy');
    }
    if (ok) haptic('success');
    if (st.mounted) dismissFast();
  }

  /* ---------- colors in the sheet ---------- */

  // The ring glides between neighbours in a row and fades across a row break.
  function placeRing(f) {
    if (!st.cx.length) return;
    var n = st.cx.length - 1;
    var i0 = clamp(Math.floor(f), 0, n);
    var i1 = Math.min(i0 + 1, n);
    var t = clamp(f - i0, 0, 1);
    var x;
    var y;
    if (Math.abs(st.cy[i0] - st.cy[i1]) < 1) {
      x = lerp(st.cx[i0], st.cx[i1], t);
      y = st.cy[i0];
      st.ringFade = 1;
    } else {
      var j = t < 0.5 ? i0 : i1;
      x = st.cx[j];
      y = st.cy[j];
      st.ringFade = Math.abs(t - 0.5) * 2;
    }
    var half = st.ring / 2;
    el.ring.style.width = st.ring + 'px';
    el.ring.style.height = st.ring + 'px';
    el.ring.style.transform = 'translate3d(' + (x - half).toFixed(2) + 'px,' + (y - half).toFixed(2) + 'px,0)';
    ringOpacity();
  }

  function paintPager() {
    if (!el.pager || !st.mounted) return;
    var f = clamp(el.pager.scrollLeft / st.pageW, 0, colors.length - 1);
    var still = REDUCED.matches;
    el.pages.forEach(function (pg, i) {
      var o = i - f;
      var a = Math.min(Math.abs(o), 1);
      pg.img.style.transform = still ? '' : 'translate3d(' + (-o * st.pageW * 0.3).toFixed(2) + 'px,0,0) scale(' + (1 - 0.08 * a).toFixed(4) + ')';
      pg.img.style.opacity = pg.img.classList.contains('is-loaded') ? (1 - 0.45 * a).toFixed(3) : '';
    });
    placeRing(f);
    var idx = Math.round(f);
    if (st.jump !== null) {
      // a tapped color: the pager glides there without naming every color it passes
      if (idx === st.jump && Math.abs(f - idx) < 0.02) st.jump = null;
      return;
    }
    if (idx !== st.shown) {
      showColor(idx, true);
      haptic('detent');
    }
  }

  function onPagerScroll() {
    if (!st.mounted) return;
    if (!st.pagerRaf) st.pagerRaf = window.requestAnimationFrame(function () { st.pagerRaf = 0; paintPager(); });
    clearTimeout(st.settleTimer);
    st.settleTimer = setTimeout(settlePager, 140);
  }

  function settlePager() {
    if (!st.mounted || (st.drag && st.drag.mode === 'sheet')) return;
    clearTimeout(st.settleTimer);
    st.jump = null;
    paintPager();
    var idx = clamp(Math.round(el.pager.scrollLeft / st.pageW), 0, colors.length - 1);
    st.pending = null;
    if (idx !== st.shown) showColor(idx, true);
    if (idx !== st.committed) commit(idx);
  }

  function showColor(idx, animate) {
    var c = colors[idx];
    if (!c || idx === st.shown) return;
    var prev = st.shown;
    st.shown = idx;
    el.ship.textContent = shipText(c);
    el.swatches.forEach(function (b, i) {
      var on = i === idx;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    var box = el.name;
    var spans = qa('span', box);
    var old = spans[spans.length - 1];
    spans.forEach(function (sp) { if (sp !== old) sp.remove(); });
    var next = document.createElement('span');
    next.textContent = c.name;
    box.appendChild(next);
    if (!old) return;
    if (!animate || prev === -1 || REDUCED.matches || !next.animate) { old.remove(); return; }
    old.animate([
      { opacity: 1, transform: 'none', filter: 'blur(0)' },
      { opacity: 0, transform: 'translate3d(0,-9px,0)', filter: 'blur(4px)' }
    ], { duration: 200, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' }).onfinish = function () { old.remove(); };
    next.animate([
      { opacity: 0, transform: 'translate3d(0,11px,0)', filter: 'blur(6px)' },
      { opacity: 1, transform: 'none', filter: 'blur(0)' }
    ], { duration: 420, easing: 'cubic-bezier(.16,1,.3,1)' });
    var dot = el.dots[idx];
    if (dot && st.p > 0.9) {
      try {
        dot.animate([{ scale: '1' }, { scale: '1.1', offset: 0.35 }, { scale: '.98', offset: 0.7 }, { scale: '1' }], { duration: 440, easing: 'ease-out' });
      } catch (e) {}
    }
  }

  function commit(idx) {
    var c = colors[idx];
    if (!c) return;
    st.committed = idx;
    var legacy = legacySwatch(c.name);
    if (legacy && !legacy.classList.contains('is-active')) legacy.click();
    push('select', c.name);
  }

  function select(i) {
    i = clamp(i, 0, colors.length - 1);
    st.pending = i;
    showColor(i, true);
    if (Math.abs(el.pager.scrollLeft - i * st.pageW) < 2) {
      st.pending = null;
      st.jump = null;
      if (i !== st.committed) commit(i);
      return;
    }
    st.jump = i;
    el.pager.scrollTo({ left: i * st.pageW, behavior: REDUCED.matches ? 'auto' : 'smooth' });
  }

  /* ---------- gestures ---------- */

  function onChipDown(e) {
    if (st.mounted || (e.pointerType === 'mouse' && e.button !== 0)) return;
    prefetch();
    st.drag = { mode: 'chip', id: e.pointerId, x: e.clientX, y: e.clientY, p0: 0, vy: 0, ly: e.clientY, lt: e.timeStamp, active: false };
    window.addEventListener('pointermove', onMove, { passive: false });
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
  }

  function onSheetDown(e) {
    if (!st.mounted || (e.pointerType === 'mouse' && e.button !== 0)) return;
    if (el.pager.contains(e.target)) st.jump = null;
    st.drag = { mode: 'sheet', id: e.pointerId, x: e.clientX, y: e.clientY, p0: st.p, vy: 0, ly: e.clientY, lt: e.timeStamp, active: false };
  }

  function onMove(e) {
    var d = st.drag;
    if (!d || e.pointerId !== d.id) return;
    var dx = e.clientX - d.x;
    var dy = e.clientY - d.y;
    if (!d.active) {
      var vertical = Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx) * 1.2;
      if (d.mode === 'chip' && vertical && dy < 0) {
        if (!mount()) { st.drag = null; return; }
        d.active = true;
        st.swallowClick = true;
        haptic('tap');
      } else if (d.mode === 'sheet' && vertical) {
        d.active = true;
        d.p0 = st.p;
      } else if (Math.abs(dx) > 8 || Math.abs(dy) > 8) {
        st.drag = null;
        return;
      } else {
        return;
      }
      stopSpring();
      st.v = 0;
    }
    var travel = st.geo ? st.geo.travel : 400;
    var p = d.p0 - dy / travel;
    if (p > 1) p = 1 + (p - 1) * 0.18;
    st.p = Math.max(0, p);
    var dt = Math.max(1, e.timeStamp - d.lt);
    d.vy = 0.75 * ((e.clientY - d.ly) / dt) + 0.25 * d.vy;
    d.ly = e.clientY;
    d.lt = e.timeStamp;
    render();
    if (e.cancelable) e.preventDefault();
  }

  function onUp(e) {
    var d = st.drag;
    if (!d || e.pointerId !== d.id) return;
    st.drag = null;
    if (d.mode === 'chip' && !st.mounted) {
      window.removeEventListener('pointermove', onMove, { passive: false });
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
    }
    if (!d.active) return;
    var travel = st.geo ? st.geo.travel : 400;
    var velocity = -(d.vy * 1000) / travel;
    var to = velocity < -1.1 ? 0 : velocity > 1.1 ? 1 : (st.p < 0.6 ? 0 : 1);
    st.focusBack = to === 0;
    animateTo(to, velocity);
    if (d.mode === 'chip') setTimeout(function () { st.swallowClick = false; }, 400);
  }

  function blockTouch(e) {
    if (!st.mounted) return;
    if (el.pager && el.pager.contains(e.target)) return;
    if (e.cancelable) e.preventDefault();
  }

  function onKey(e) {
    if (!st.mounted) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      st.focusBack = true;
      animateTo(0);
      return;
    }
    if (e.key === 'Tab') {
      var list = [el.x, el.swatches[Math.max(0, st.shown)], cta()].filter(Boolean);
      var at = list.indexOf(document.activeElement);
      e.preventDefault();
      list[(at + (e.shiftKey ? -1 : 1) + list.length) % list.length].focus({ preventScroll: true });
      return;
    }
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('bl-swatch')) return;
    var i = Number(t.getAttribute('data-i'));
    var n = colors.length;
    var next = null;
    if (e.key === 'ArrowRight') next = (i + 1) % n;
    else if (e.key === 'ArrowLeft') next = (i - 1 + n) % n;
    else if (e.key === 'ArrowDown') next = Math.min(n - 1, i + 4);
    else if (e.key === 'ArrowUp') next = Math.max(0, i - 4);
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = n - 1;
    if (next === null) return;
    e.preventDefault();
    el.swatches[next].focus({ preventScroll: true });
    select(next);
  }

  /* ---------- wiring ---------- */

  // Registered before the sticky add-to-cart handler, so the chosen color is
  // committed before the item is added and a second tap cannot add twice.
  window.addEventListener('click', function (e) {
    var button = e.target && e.target.closest ? e.target.closest('#sticky-atc .sticky-atc-btn') : null;
    var b = bar();
    if (!button || !b || !b.classList.contains('bl-sheet') || !PHONE.matches) return;
    if (st.adding) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    if (st.mounted) {
      var want = st.pending !== null ? st.pending : st.shown;
      if (want !== st.committed && colors[want]) commit(want);
      if (!buyable(button)) return;
      push('add_to_cart', colors[want] && colors[want].name);
    } else if (!buyable(button)) {
      return;
    }
    haptic('tap');
    startAdding(button);
  }, true);

  ['theme:cart:added', 'theme:cart:open', 'cart:open', 'ajaxProduct:added'].forEach(function (name) {
    document.addEventListener(name, function () { if (st.adding) finishAdding(true); });
  });

  function enter(b) {
    if (REDUCED.matches || !b.animate || !PHONE.matches) return;
    b.animate([
      { opacity: 0, transform: 'translate3d(0,100%,0)' },
      { opacity: 1, transform: 'none' }
    ], { duration: 420, easing: 'cubic-bezier(.2,.8,.2,1)' });
    var dot = q('.bl-chip__dot', b);
    if (dot) {
      dot.animate([
        { opacity: 0, transform: 'scale(.6)' },
        { opacity: 1, transform: 'scale(1.08)', offset: 0.6 },
        { opacity: 1, transform: 'none' }
      ], { duration: 460, delay: 180, easing: 'cubic-bezier(.25,.8,.3,1)', fill: 'backwards' });
    }
    if (st.nudged) return;
    st.nudged = true;
    var chev = q('.bl-chip__chev', b);
    if (chev) {
      chev.animate([
        { transform: 'none' },
        { transform: 'translate3d(0,-3px,0)', offset: 0.3 },
        { transform: 'none', offset: 0.6 },
        { transform: 'none' }
      ], { duration: 1100, delay: 1100, iterations: 2, easing: 'ease-in-out' });
    }
  }

  function init() {
    var b = bar();
    if (!b || b.classList.contains('bl-sheet')) return;
    colors = readColors();
    if (colors.length < 2) return;
    injectStyles();
    if (!buildChip()) return;
    b.classList.add('bl-sheet');
    document.documentElement.classList.add('bl-sheet-ready');
    updateChip();
    // lets iOS show :active press states
    document.addEventListener('touchstart', function () {}, { passive: true });

    var summary = document.getElementById('sticky-atc-selected-summary');
    if (summary && window.MutationObserver) {
      new MutationObserver(function () { if (!st.mounted) updateChip(); }).observe(summary, { childList: true, characterData: true, subtree: true });
    }
    document.addEventListener('variant:change', function () { setTimeout(function () { if (!st.mounted) updateChip(); }, 0); });

    if (window.MutationObserver) {
      var visible = b.getAttribute('aria-hidden') === 'false';
      var prefetched = false;
      new MutationObserver(function () {
        var now = b.getAttribute('aria-hidden') === 'false';
        if (now && !visible) {
          enter(b);
          if (!prefetched) {
            prefetched = true;
            if ('requestIdleCallback' in window) window.requestIdleCallback(prefetch, { timeout: 2000 });
            else setTimeout(prefetch, 600);
          }
        }
        if (!now && st.adding) finishAdding(true);
        else if (!now && st.mounted) unmount(false);
        visible = now;
      }).observe(b, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    var onChange = function () { if (!PHONE.matches) unmount(false); };
    if (PHONE.addEventListener) PHONE.addEventListener('change', onChange);
    else if (PHONE.addListener) PHONE.addListener(onChange);
    window.addEventListener('pagehide', function () { finishAdding(false); unmount(false); });
    window.addEventListener('resize', function () {
      if (!st.mounted) return;
      var p = st.p;
      measure();
      el.pager.scrollLeft = st.shown * st.pageW;
      st.p = p;
      paintPager();
      render();
    });
  }

  // Deferred scripts run before the sticky bar's own scripts build the
  // swatches, so start on DOMContentLoaded and retry briefly if needed.
  var tries = 0;
  function boot() {
    init();
    var b = bar();
    if (b && !b.classList.contains('bl-sheet') && tries < 4) {
      tries += 1;
      setTimeout(boot, 250 * tries);
    }
  }
  if (document.readyState === 'complete') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();